import React from 'react';
import {
    iconSearch,
    iconDropdown,
    iconDownload,
    iconPrint,
    iconCheck
} from '../../../assets';
import { classes } from 'typestyle';
import { iconMirrorringXClassName, iconMirrorringYClassName } from './icon.style';

interface IconProps {
    name: IconName,
    alt?: string,
    width?: string,
    height?: string,
    mirroring?: 'x' | 'y',
    className?: string
}

type IconName = 'magnifyingGlass' | 'download' | 'print' | 'dropdown' | 'check';

const Icon: React.FC<IconProps> = ({
    name,
    alt,
    width,
    height,
    mirroring,
    className
}) => (
    <img
        alt={ alt }
        width={ width }
        height={ height }
        className={ classes(
            mirroring === 'x' ? iconMirrorringXClassName : undefined,
            mirroring === 'y' ? iconMirrorringYClassName : undefined,
            className,
        ) }
        src={ (() => {
            switch(name) {
                case 'download': return iconDownload;
                case 'magnifyingGlass': return iconSearch;
                case 'print': return iconPrint;
                case 'dropdown': return iconDropdown;
                case 'check': return iconCheck;
            }
        })() }/>
);

export default Icon;
